import { render, staticRenderFns } from "./SalePaymentView.vue?vue&type=template&id=2c2757af"
import script from "./SalePaymentView.vue?vue&type=script&lang=js"
export * from "./SalePaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports